// Bölge Müdürleri Raporları sayfası. Çalışan tablosu, filtreler ve rapor
// bölümü SMO Lead Raporları ile ortaktır; onların metinleri smoLead altındadır.
// Excel dosyaları Türkçe kalır.
const regionReports = {
  title: 'Bölge Müdürleri Raporları',
  breadcrumb: 'Raporlar / Bölge Müdürleri Raporları',

  stats: {
    totalRegions: 'Toplam Bölge Sayısı',
    centers: 'Bölgedeki Merkez Sayısı',
    workers: 'Bu Bölgede Çalışan Sayısı',
  },

  picker: {
    title: 'Bölge Müdürleri',
    subtitle: 'Detayları görmek için bir bölge seçiniz',
    loading: 'Bölge müdürleri yükleniyor...',
    emptyAdmin: 'Henüz bölge müdürü atanmış bölge bulunmuyor. Merkez Yönetimi sayfasındaki “Bölge Yönetimi” ekranından bölge ve bölge müdürü tanımlayabilirsiniz.',
    emptyOwn: 'Size atanmış bir bölge bulunmuyor.',
    counts: '{{centers}} Merkez · {{cities}} İl',
    cityLegend: '“Bölge / İl” yazan kartlar, bölgenin yalnızca o ilinden sorumlu müdürün görünümüdür.',
    toggleHint: 'Seçili bölgeye tekrar tıklarsanız seçim kaldırılır.',
  },

  team: {
    title: '{{region}} — {{name}} - Çalışanlar',
    subtitle: 'Bölgenin illerindeki merkezlerde atanmış çalışanlar ve projeleri. Kenar rengi bölgenin rengidir.',
    loading: 'Çalışanlar yükleniyor...',
    noMatch: 'Arama kriterine uygun çalışan bulunamadı.',
    empty: 'Bu bölgede çalışan bulunmamaktadır.',
  },

  projectless: {
    title: 'Projesiz Çalışanlar',
    text: 'Hiçbir projede aktif merkez ataması olmayan, Çalışan Yönetimi’nde “Çalıştığı İl”i bu bölgede olan çalışanlar. Takvimleri Operasyon Yönetimi’nde görüntülenebilir; bir merkeze atandıklarında yukarıdaki listeye geçerler.',
  },

  filters: {
    search: 'Çalışan, proje, merkez veya il ara...',
    help: 'Filtreler çalışanların proje atamalarına uygulanır; eşleşen ataması kalmayan çalışan listeden çıkar. Arama il adlarını da kapsar.',
  },

  summary: {
    title: 'Operasyonel Genel Bakış',
    text: 'Bölgedeki çalışanların seçilen dönemdeki vizitlerinin özeti: kalite, SLA, dokümantasyon ve kat edilen mesafe.',
    status: '{{total}} vizit analiz edildi ({{home}} ev / {{site}} hastane)',
    monthlyTrend: 'Aylık Vizit Trendi',
    workerChart: 'Çalışan Bazında Vizit Dağılımı',
    workerChartHelp: 'En çok vizit yapan 12 çalışan gösterilir; kırmızı çubuk sorunlu vizit sayısıdır.',
  },

  toast: {
    managersError: 'Bölge müdürleri yüklenirken hata oluştu!',
    workersError: 'Çalışan bilgileri yüklenirken hata oluştu!',
    noVisits: 'Bu çalışanın bu projedeki visit’i bulunamadı.',
    excelDownloaded: 'Excel dosyası başarıyla indirildi',
    summaryExcel: 'Operasyonel Özet Excel indirildi',
  },
};

export default regionReports;
